import { gql } from '@apollo/client'

export const SEARCH_PAGE_SIZE = 9

export const SERVICE_CATEGORIES_QUERY = gql`
  query ServiceCategories {
    serviceCategories {
      id
      name
      nameEl
      translationKey
      description
      descriptionEl
      icon
      position
      serviceTypes {
        id
        name
        nameEl
        translationKey
        description
        descriptionEl
        basePriceCents
        estimatedDurationMinutes
      }
    }
  }
`

export const SEARCH_PROVIDERS_QUERY = gql`
  query SearchProviders($input: SearchProvidersInput!) {
    searchProviders(input: $input) {
      providers {
        id
        bio
        yearsExperience
        hourlyRateCents
        averageRating
        totalReviews
        completedJobs
        verified
        languages
        user {
          firstName
          lastName
          avatarUrl
        }
        serviceTypes {
          id
          name
          nameEl
          translationKey
        }
        serviceAreas {
          postalCode
          areaName
          city
        }
      }
      totalCount
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`

export interface ServiceType {
  id: string
  name: string
  nameEl: string
  translationKey: string
  description: string | null
  descriptionEl: string | null
  basePriceCents: number
  estimatedDurationMinutes: number
}

export interface ServiceCategory {
  id: string
  name: string
  nameEl: string
  translationKey: string
  description: string | null
  descriptionEl: string | null
  icon: string | null
  position: number
  serviceTypes: ServiceType[]
}

export interface ServiceCategoriesData {
  serviceCategories: ServiceCategory[]
}

export interface ProviderUserSummary {
  firstName: string
  lastName: string
  avatarUrl: string | null
}

export interface ProviderServiceTypeSummary {
  id: string
  name: string
  nameEl: string
  translationKey: string
}

export interface ProviderServiceAreaSummary {
  postalCode: string
  areaName: string | null
  city: string
}

export interface SearchProviderSummary {
  id: string
  bio: string | null
  yearsExperience: number | null
  hourlyRateCents: number | null
  averageRating: number
  totalReviews: number
  completedJobs: number
  verified: boolean
  languages: string[]
  user: ProviderUserSummary
  serviceTypes: ProviderServiceTypeSummary[]
  serviceAreas: ProviderServiceAreaSummary[]
}

export interface SearchPageInfo {
  hasNextPage: boolean
  endCursor: string | null
}

export interface SearchProvidersData {
  searchProviders: {
    providers: SearchProviderSummary[]
    totalCount: number
    pageInfo: SearchPageInfo
  }
}

export type SearchProvidersSortBy = 'RATING' | 'PRICE' | 'EXPERIENCE' | 'COMPLETED_JOBS'
export type SortOrder = 'ASC' | 'DESC'

export interface SearchProvidersInput {
  postalCode: string
  serviceTypeId?: string
  date?: string
  page?: number
  perPage?: number
  sortBy?: SearchProvidersSortBy
  sortOrder?: SortOrder
}

export interface SearchProvidersVariables {
  input: SearchProvidersInput
}
